import { LOCALES } from 'i18n/locales';

export const workpackAlertWarningIntl = {
    [LOCALES.ENGLISH]: {
        'workpackAlertWarning.title': 'Warning',
        'workpackAlertWarning.text': 'NUAR does not provide Health & Safety instructions or risk‑assessment advice, and no risk triage occurs when a PDF map is created. NUAR supports desktop survey only; all safe‑dig procedures in HSG47 and other industry guidance should still be followed.'
    },
    [LOCALES.WELSH]: {
        'workpackAlertWarning.title': '[Warning]',
        'workpackAlertWarning.text': '[NUAR does not provide Health & Safety instructions or risk‑assessment advice, and no risk triage occurs when a PDF map is created. NUAR supports desktop survey only; all safe‑dig procedures in HSG47 and other industry guidance should still be followed.]'
    }
};
